<div class="timeline">

  <div
    class="timeline__item"
    *ngFor="let item of timeline"
  >
    <div class="timeline__item-date">
      {{item.formatted_date}}
    </div>
    <div class="timeline__item-info">
      <div class="timeline__item-icon">
        <mat-icon>check</mat-icon>
      </div>
      <p class="timeline__item-title">
        {{item.title}}
      </p>
<!--      <p class="timeline__item-description">-->
<!--        {{item.description}}-->
<!--      </p>-->
    </div>
  </div>

</div>
